import httpClient from './httpClient'

export default {
  async getAllsubUsers() {
    let ret = await httpClient.get('users')
    return ret
  },
  async getAsubUser(userId) {
    let ret = await httpClient.get(`users/${userId}`)
    return ret
  },
  async createUser(data) {
    let ret = await httpClient.post('users', data)
    return ret
  },
  async updateUser(userId, data) {
    let ret = await httpClient.put(`users/${userId}`, data)
    return ret
  },
  async removeUser(userId) {
    let ret = await httpClient.delete(`users/${userId}`)
    return ret
  },
}
